<template>
    <div>
        <div class="d-flex justify-content-center">
            <b-overlay :show="!ready">
                <div class="d-flex flex-column align-items-center" v-if="ready">
                    <h4>Membership Completion</h4>
                    <div class="align-items-center">
                        <img src="@/assets/images/client_logo_alpha.webp" alt height="150" />
                    </div>
        
                    <h3>Hi {{ completion_data.first_name }}</h3>
                    <span>Please read through the membership agreement and confirm your acceptance to join</span>
                    <span>A copy will be mailed to you on acceptance</span>
                    
                    <hr />
                    
                    <div class="pdf-viewer-container">
                        <div v-show="pdfLoading" class="spinner-container">
                            <b-spinner label="Loading PDF..."></b-spinner>
                        </div>

                        <div v-show="!pdfLoading">
                            <div v-if="pageCount > 1" class="pdf-controls d-flex justify-content-center align-items-center mb-2">
                                <b-button @click="prevPage" :disabled="currentPage <= 1" size="sm" class="mr-2">Previous</b-button>
                                <span>Page {{ currentPage }} of {{ pageCount }}</span>
                                <b-button @click="nextPage" :disabled="currentPage >= pageCount" size="sm" class="ml-2">Next</b-button>
                            </div>

                            <vue-pdf-embed 
                                :source="completion_data.agreement_src"
                                :page="currentPage"
                                ref="pdfRef"
                                @rendered="handleDocumentRender"
                            />
                        </div>
                    </div>
                        
                    <div class="modal-footer mt-4">
                        <b-button @click="showModal" variant="primary">Confirm Membership</b-button>
                    </div>
                </div>
            </b-overlay>
        </div>

        <b-modal v-model="modalVisible" hide-footer>
            <template #modal-title>
                Confirm Membership
            </template>
            <b-overlay :show="busySaving">
                <div>
                    <h5>
                        I, {{ completion_data.first_name }} {{ completion_data.last_name }} (ID No. {{ completion_data.id_no }}),
                        confirm that I accept the End User Agreement.
                    </h5>
                </div>
                <div>
                    <b-alert show variant="info">Please upload a picture of your ID/Drivers License or a PDF document to complete this agreement</b-alert>
                    <uploader
                        :options="renderUploadOptions"
                        :autoStart="false"
                        :ref="'id_upload'"
                        class="uploader-example mt-3"
                        @file-added="onFileAdded"
                    >
                    <uploader-unsupport></uploader-unsupport>
                    <uploader-drop>
                        <p>Drop file here to upload or</p>
                        <uploader-btn type="button" :single="true">Select Image or PDF</uploader-btn>
                    </uploader-drop>
                    <uploader-list></uploader-list>
                    </uploader>
                </div>
                <div class="mt-3 d-flex justify-content-end">
                    <b-button variant="danger" @click="modalVisible = false">Cancel</b-button>
                    <b-button v-show="idAdded" variant="primary" class="ml-2" @click="confirmMembership">Complete Membership</b-button>
                </div>
            </b-overlay>
        </b-modal>

    </div>
</template>

<script>
import { crmMethods, crmComputed } from "@/state/helpers";
import Swal from "sweetalert2";
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';

export default {
    components: {
        VuePdfEmbed,
    },
    data: () => ({
        ready: false,
        modalVisible: false,
        idAdded: false,
        busySaving: false,
        currentPage: 0,
        pageCount: 1,
        pdfLoading: true,
    }),
    computed: {
        ...crmComputed,
        renderUploadOptions() {
            let url = process.env.VUE_APP_API_BASEURL + "api/crm/upload_id";
            let options = {
                target: url,
                query: {
                    client_id: "",
                    token: this.$route.params.token,
                },
                testChunks: false,
                simultaneousUploads: 1, 
                fileParameterName: 'image',
                singleFile: true,
                accept: ['image/*', 'application/pdf'],
            };
            return options;
        },
    },
    methods: {
        ...crmMethods,
        /*handleLoadingState(isLoading) {
            this.pdfLoading = isLoading;
        },*/
        handleDocumentRender() {
            // ----- THE FIX IS HERE -----
            // The event emits the page count as a number directly.
            this.pageCount = this.$refs.pdfRef.pageCount;
            this.pdfLoading = false;
            if (this.currentPage == 0) {
                this.currentPage = 1;
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
            }
        },
        nextPage() {
            if (this.currentPage < this.pageCount) {
                this.currentPage++;
            }
        },
        refreshPage() {
            window.location.reload();
        },
        onFileAdded() {
            this.idAdded = true;
        },
        showModal() {
            this.modalVisible = true;
        },
        confirmMembership() {
            this.busySaving = true;
            this.finaliseMembership({token: this.$route.params.token}).then((response) => {
                this.handleIdUpload(response.client_id);
            });
        },
        handleIdUpload(clientId) {
            const uploaderInstance = this.$refs['id_upload'];
            const upload = uploaderInstance.uploader;
            upload.opts.query.client_id = clientId;

            upload.resume();
            upload.on('fileSuccess', () => {
                this.busySaving = false;
                this.modalVisible = false;
                Swal.fire({
                    title: 'Account Created',
                    text: 'Your login details will be mailed to you. Please check your email.',
                    icon: 'success',
                    confirmButtonText: 'OK'
                }).then(() => {
                    window.location.href = process.env.VUE_APP_UI_BASEURL;
                });
            });
            upload.on('fileError', (rootFile, file, message) => {
                console.error("Upload failed:", message);
                this.busySaving = false;
                Swal.fire({
                    title: 'Upload Failed',
                    text: 'There was an error uploading your file. Please try again.',
                    icon: 'error',
                });
            });
        }
    },
    mounted() {
        this.getMembershipCompletionData(this.$route.params.token).then(() => {
            this.ready = true;
        });
    },
};
</script>

<style lang="scss" scoped>
.mw-500 {
    max-width: 500px !important;
}
.input-500 {
    width: 500px;
}

@media only screen and (max-width: 510px) {
    .input-500 {
        width: 300px;
    }
}
@media only screen and (max-width: 310px) {
    .input-500 {
        width: 200px;
    }
}

.pdf-viewer-container {
    width: 100%;
    max-width: 600px;
    border: 1px solid #ddd;
    padding: 1rem;
    position: relative;
    min-height: 200px;
}

.spinner-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
}

@media (max-width: 768px) {
    .pdf-viewer-container  {
        max-width: 350px;
    }
}
</style>